import * as Yup from "yup"

const DeferActionValidation = {
    deadline: Yup.string().required('Il campo è obbligatorio'),
}

export default Yup.object()
    .shape(
        DeferActionValidation,
    )
    .required()
